import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Chip,
  TextField,
  Button,
  MenuItem,
  Tooltip,
  IconButton,
} from '@mui/material';
import {
  Assignment as AuditIcon,
  Today as TodayIcon,
  DateRange as WeekIcon,
  SupervisorAccount as AdminsIcon,
  ErrorOutline as FailedIcon,
  Download as DownloadIcon,
  ContentCopy as CopyIcon,
} from '@mui/icons-material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import StatCard from '../components/StatCard';
import apiClient from '../services/api/apiClient';

interface AuditLog {
  id: string;
  timestamp: string;
  admin_email: string;
  admin_name: string;
  action: string;
  target_type: string;
  target_id: string;
  details: string;
  ip_address: string;
  status: 'success' | 'failed';
}

const MOCK_LOGS: AuditLog[] = [
  { id: '1',  timestamp: '2026-04-16T08:02:11Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'approve',  target_type: 'verification', target_id: 'ver_Kq8m2Xw',  details: 'Approved artisan NIN verification',          ip_address: '197.210.44.12',  status: 'success' },
  { id: '2',  timestamp: '2026-04-16T08:15:33Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'reject',   target_type: 'verification', target_id: 'ver_Pz3nLrt',  details: 'Rejected blurry CAC document',               ip_address: '197.210.44.12',  status: 'success' },
  { id: '3',  timestamp: '2026-04-16T08:44:05Z', admin_email: 'tolu@daily2k.com',    admin_name: 'Tolu Adeyemi',   action: 'suspend',  target_type: 'user',         target_id: 'usr_Hn7vBq1',  details: 'Suspended user for repeated no-shows',       ip_address: '41.58.120.77',   status: 'success' },
  { id: '4',  timestamp: '2026-04-16T09:01:22Z', admin_email: 'tolu@daily2k.com',    admin_name: 'Tolu Adeyemi',   action: 'delete',   target_type: 'job',          target_id: 'job_Wm5cDz9',  details: 'Deleted spam job listing',                   ip_address: '41.58.120.77',   status: 'success' },
  { id: '5',  timestamp: '2026-04-16T09:17:58Z', admin_email: 'chidi@daily2k.com',   admin_name: 'Chidi Nwosu',    action: 'update',   target_type: 'payment',      target_id: 'pay_Rt4kEf2',  details: 'Updated escrow hold amount (NGN 45,000)',    ip_address: '105.112.88.43',  status: 'success' },
  { id: '6',  timestamp: '2026-04-16T09:35:14Z', admin_email: 'chidi@daily2k.com',   admin_name: 'Chidi Nwosu',    action: 'create',   target_type: 'service',      target_id: 'svc_Lp9mJv3',  details: 'Created new "Fumigation" service category',  ip_address: '105.112.88.43',  status: 'success' },
  { id: '7',  timestamp: '2026-04-16T09:52:44Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'ban',      target_type: 'user',         target_id: 'usr_Ac2xNe6',  details: 'Permanently banned fraudulent artisan',      ip_address: '197.210.44.12',  status: 'success' },
  { id: '8',  timestamp: '2026-04-16T10:10:02Z', admin_email: 'tolu@daily2k.com',    admin_name: 'Tolu Adeyemi',   action: 'approve',  target_type: 'dispute',      target_id: 'dsp_Ov6bSu7',  details: 'Resolved dispute in favour of client',       ip_address: '41.58.120.77',   status: 'success' },
  { id: '9',  timestamp: '2026-04-16T10:28:37Z', admin_email: 'amaka@daily2k.com',   admin_name: 'Amaka Eze',      action: 'login',    target_type: 'system',       target_id: 'sys_admin',    details: 'Admin panel login',                          ip_address: '154.118.22.91',  status: 'success' },
  { id: '10', timestamp: '2026-04-16T10:30:55Z', admin_email: 'amaka@daily2k.com',   admin_name: 'Amaka Eze',      action: 'update',   target_type: 'user',         target_id: 'usr_Gj4wPk8',  details: 'Updated user profile details',               ip_address: '154.118.22.91',  status: 'success' },
  { id: '11', timestamp: '2026-04-16T10:48:19Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'export',   target_type: 'payment',      target_id: 'bulk_export',  details: 'Exported April 2026 payment report (CSV)',   ip_address: '197.210.44.12',  status: 'success' },
  { id: '12', timestamp: '2026-04-16T11:03:41Z', admin_email: 'chidi@daily2k.com',   admin_name: 'Chidi Nwosu',    action: 'reject',   target_type: 'dispute',      target_id: 'dsp_Kb3mTx5',  details: 'Rejected dispute — insufficient evidence',   ip_address: '105.112.88.43',  status: 'success' },
  { id: '13', timestamp: '2026-04-16T11:22:08Z', admin_email: 'tolu@daily2k.com',    admin_name: 'Tolu Adeyemi',   action: 'delete',   target_type: 'user',         target_id: 'usr_Yn1pQr4',  details: 'Deleted test account',                       ip_address: '41.58.120.77',   status: 'success' },
  { id: '14', timestamp: '2026-04-16T11:45:30Z', admin_email: 'amaka@daily2k.com',   admin_name: 'Amaka Eze',      action: 'update',   target_type: 'job',          target_id: 'job_Df8cZq1',  details: 'Manually set job status to completed',       ip_address: '154.118.22.91',  status: 'success' },
  { id: '15', timestamp: '2026-04-16T12:00:00Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'login',    target_type: 'system',       target_id: 'sys_admin',    details: 'Admin panel login',                          ip_address: '197.210.55.88',  status: 'failed'  },
  { id: '16', timestamp: '2026-04-16T12:01:44Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'login',    target_type: 'system',       target_id: 'sys_admin',    details: 'Admin panel login',                          ip_address: '197.210.44.12',  status: 'success' },
  { id: '17', timestamp: '2026-04-15T14:22:10Z', admin_email: 'chidi@daily2k.com',   admin_name: 'Chidi Nwosu',    action: 'create',   target_type: 'user',         target_id: 'usr_Mx9vFa5',  details: 'Manually created artisan account',           ip_address: '105.112.88.43',  status: 'success' },
  { id: '18', timestamp: '2026-04-15T15:50:27Z', admin_email: 'tolu@daily2k.com',    admin_name: 'Tolu Adeyemi',   action: 'update',   target_type: 'service',      target_id: 'svc_Ej7nWb2',  details: 'Updated "Plumbing" category description',   ip_address: '41.58.120.77',   status: 'success' },
  { id: '19', timestamp: '2026-04-15T16:33:55Z', admin_email: 'amaka@daily2k.com',   admin_name: 'Amaka Eze',      action: 'approve',  target_type: 'verification', target_id: 'ver_Cu5rOm9',  details: 'Approved artisan professional certificate',  ip_address: '154.118.22.91',  status: 'success' },
  { id: '20', timestamp: '2026-04-15T17:10:44Z', admin_email: 'niyi@daily2k.com',    admin_name: 'Niyi Olagbegi',  action: 'delete',   target_type: 'job',          target_id: 'job_Qh2dAn6',  details: 'Deleted duplicate job posting',              ip_address: '197.210.44.12',  status: 'success' },
  { id: '21', timestamp: '2026-04-15T09:05:18Z', admin_email: 'chidi@daily2k.com',   admin_name: 'Chidi Nwosu',    action: 'export',   target_type: 'user',         target_id: 'bulk_export',  details: 'Exported verified artisan list (CSV)',       ip_address: '105.112.88.43',  status: 'success' },
  { id: '22', timestamp: '2026-04-14T11:40:02Z', admin_email: 'tolu@daily2k.com',    admin_name: 'Tolu Adeyemi',   action: 'ban',      target_type: 'user',         target_id: 'usr_Sk3tIr7',  details: 'Banned user for payment fraud',              ip_address: '41.58.120.77',   status: 'success' },
];

function getActionColor(action: string): 'success' | 'info' | 'error' | 'warning' | 'default' {
  if (['approve', 'create'].includes(action)) return 'success';
  if (['update', 'login'].includes(action)) return 'info';
  if (['delete', 'ban', 'reject'].includes(action)) return 'error';
  if (['suspend', 'export'].includes(action)) return 'warning';
  return 'default';
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function AuditLogsPage() {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [filtered, setFiltered] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });

  // Filters
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo]     = useState('');
  const [adminSearch, setAdminSearch] = useState('');
  const [actionFilter, setActionFilter] = useState('');
  const [targetFilter, setTargetFilter] = useState('');

  const [copiedId, setCopiedId] = useState<string | null>(null);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await apiClient.get('/admin/audit-logs/', { params: { limit: 200 } });
        const results = res.data?.data?.results ?? [];
        setLogs(results);
      } catch {
        setLogs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

  useEffect(() => {
    let result = [...logs];
    if (dateFrom)      result = result.filter(l => l.timestamp >= dateFrom);
    if (dateTo)        result = result.filter(l => l.timestamp <= dateTo + 'T23:59:59Z');
    if (adminSearch)   result = result.filter(l =>
      l.admin_email.toLowerCase().includes(adminSearch.toLowerCase()) ||
      l.admin_name.toLowerCase().includes(adminSearch.toLowerCase()));
    if (actionFilter)  result = result.filter(l => l.action === actionFilter);
    if (targetFilter)  result = result.filter(l => l.target_type === targetFilter);
    setFiltered(result);
  }, [logs, dateFrom, dateTo, adminSearch, actionFilter, targetFilter]);

  const today = new Date().toISOString().slice(0, 10);
  const weekAgo = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);
  const todayCount  = logs.filter(l => l.timestamp.startsWith(today)).length;
  const weekCount   = logs.filter(l => l.timestamp.slice(0, 10) >= weekAgo).length;
  const activeAdmins = new Set(logs.filter(l => l.timestamp.startsWith(today)).map(l => l.admin_email)).size;
  const failedCount  = logs.filter((l: any) => l.status === 'failed').length;

  const handleCopy = (id: string) => {
    navigator.clipboard.writeText(id).catch(() => {});
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1500);
  };

  const handleExportCSV = () => {
    const headers = ['Timestamp', 'Admin', 'Action', 'Target Type', 'Target ID', 'Details', 'IP Address', 'Status'];
    const rows = filtered.map(l => [
      l.timestamp, l.admin_email, l.action, l.target_type, l.target_id,
      `"${l.details}"`, l.ip_address, l.status,
    ]);
    const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = `audit-logs-${today}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const columns: GridColDef[] = [
    {
      field: 'timestamp',
      headerName: 'Timestamp',
      width: 160,
      renderCell: (params: GridRenderCellParams) => (
        <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
          {formatDateTime(params.value)}
        </Typography>
      ),
    },
    {
      field: 'admin_name',
      headerName: 'Admin',
      width: 170,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Box>
          <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>{params.value}</Typography>
          <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary' }}>
            {params.row.admin_email}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 110,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          label={params.value}
          color={getActionColor(params.value)}
          size="small"
          sx={{ textTransform: 'capitalize', fontWeight: 600 }}
        />
      ),
    },
    {
      field: 'target_type',
      headerName: 'Target Type',
      width: 120,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          label={params.value}
          variant="outlined"
          size="small"
          sx={{ textTransform: 'capitalize' }}
        />
      ),
    },
    {
      field: 'target_id',
      headerName: 'Target ID',
      width: 130,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'monospace',
              fontSize: '0.78rem',
              color: 'text.secondary',
              maxWidth: 90,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {params.value}
          </Typography>
          <Tooltip title={copiedId === params.value ? 'Copied!' : 'Copy ID'}>
            <IconButton size="small" onClick={() => handleCopy(params.value)} sx={{ p: 0.25 }}>
              <CopyIcon sx={{ fontSize: '0.85rem' }} />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: 'details',
      headerName: 'Details',
      flex: 2,
      minWidth: 220,
      renderCell: (params: GridRenderCellParams) => (
        <Typography
          variant="body2"
          sx={{ fontSize: '0.82rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'ip_address',
      headerName: 'IP Address',
      width: 130,
      renderCell: (params: GridRenderCellParams) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 90,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          label={params.value}
          color={params.value === 'success' ? 'success' : 'error'}
          size="small"
          sx={{ textTransform: 'capitalize', fontWeight: 600 }}
        />
      ),
    },
  ];

  const paginatedRows = filtered.slice(
    paginationModel.page * paginationModel.pageSize,
    (paginationModel.page + 1) * paginationModel.pageSize,
  );

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
            Audit Logs
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Full record of all administrative actions performed on the platform
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleExportCSV}
          disabled={loading || filtered.length === 0}
        >
          Export CSV
        </Button>
      </Box>

      {/* Stat Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Actions Today"
            value={todayCount}
            subtitle="Across all admins"
            icon={<TodayIcon />}
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Actions This Week"
            value={weekCount}
            subtitle="Last 7 days"
            icon={<WeekIcon />}
            color="info"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Active Admins"
            value={activeAdmins}
            subtitle="Acting today"
            icon={<AdminsIcon />}
            color="success"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Failed Actions"
            value={failedCount}
            subtitle="Errors &amp; denied attempts"
            icon={<FailedIcon />}
            color="error"
          />
        </Grid>
      </Grid>

      {/* Filters */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                fullWidth
                size="small"
                label="From Date"
                type="date"
                value={dateFrom}
                onChange={e => setDateFrom(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                fullWidth
                size="small"
                label="To Date"
                type="date"
                value={dateTo}
                onChange={e => setDateTo(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search admin email or name..."
                value={adminSearch}
                onChange={e => setAdminSearch(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                fullWidth
                size="small"
                select
                label="Action Type"
                value={actionFilter}
                onChange={e => setActionFilter(e.target.value)}
              >
                <MenuItem value="">All Actions</MenuItem>
                {['create','update','delete','approve','reject','suspend','ban','login','export'].map(a => (
                  <MenuItem key={a} value={a} sx={{ textTransform: 'capitalize' }}>{a}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                fullWidth
                size="small"
                select
                label="Target Type"
                value={targetFilter}
                onChange={e => setTargetFilter(e.target.value)}
              >
                <MenuItem value="">All Types</MenuItem>
                {['user','job','payment','dispute','verification','service','system'].map(t => (
                  <MenuItem key={t} value={t} sx={{ textTransform: 'capitalize' }}>{t}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <Button
                fullWidth
                variant="outlined"
                size="small"
                onClick={() => {
                  setDateFrom(''); setDateTo(''); setAdminSearch('');
                  setActionFilter(''); setTargetFilter('');
                }}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Data Table */}
      <Card>
        <CardContent sx={{ p: 0 }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                width: '100%',
                '& .MuiDataGrid-root': { border: 'none', borderRadius: 0 },
                '& .MuiDataGrid-cell': { borderColor: 'divider' },
                '& .MuiDataGrid-columnHeader': {
                  backgroundColor: 'background.default',
                  borderColor: 'divider',
                  fontWeight: 600,
                },
                '& .MuiDataGrid-row:hover': { backgroundColor: 'action.hover' },
                '& .MuiDataGrid-footerContainer': { borderColor: 'divider' },
              }}
            >
              <DataGrid
                rows={paginatedRows}
                columns={columns}
                rowCount={filtered.length}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[25, 50, 100]}
                paginationMode="server"
                disableRowSelectionOnClick
                rowHeight={56}
                sx={{ minHeight: 400 }}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </Container>
  );
}
